import { axios } from '@/utils/request'
const api = {
  source: '/finance/enterpriseStatement',
  remove:'/finance/enterpriseStatement/majorStatement'
}
export function getSourceList (parameter) {
  return axios({
    url: api.source + '/list',
    method: 'get',
    params: parameter
  })
}
export function getexportList (parameter) {
  return axios({
    url: '/finance/enterpriseStatement/export',
    method: 'get',
    params: parameter,
    responseType: 'arraybuffer',
    headers: {
      'Content-Type': 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
    }
  })
}
export function applyCancel (parameter) {
  return axios({
    url:  '/finance/enterpriseStatement/applyCancel',
    method: 'get',
    params: parameter
  })
}
export function apply (parameter) {
  return axios({
    url:  '/finance/enterpriseStatement/apply',
    method: 'get',
    params: parameter
  })
}
export function saveRemark (parameter) {
  return axios({
    url: '/finance/enterpriseStatement/saveRemark',
    method: 'post',
    data: parameter,
    headers: {
      'Content-Type': 'application/json;charset=UTF-8'
    }
  })
}
export function invoice (parameter) {
  return axios({
    url: '/finance/enterpriseStatement/invoice',
    method: 'post',
    params: parameter,
  })
}
export function invoiceCancel (parameter) {
  return axios({
    url: '/finance/enterpriseStatement/invoiceCancel',
    method: 'post',
    params: parameter,
  })
}
export function getsubSettleList (parameter) {
  return axios({
    url: api.source + '/subSettleList',
    method: 'get',
    params: parameter
  })
}
export function removeSettleList (parameter) {
  return axios({
    url: api.remove + '/remove',
    method: 'get',
    params: parameter
  })
}
// 编辑按钮

export function getEditList (parameter) {
  return axios({
    url: api.source + '/detail',
    method: 'get',
    params: parameter
  })
}
// 主菜单的批量结算按钮
export function getmajorSettleList (parameter) {
  return axios({
    url: api.source + '/majorSettleList',
    method: 'get',
    params: parameter
  })
}
export const sourceExport = api.source + '/export'